<div class="manage-suppliers-container">
  <div class="manage-suppliers" appUserManual [userManualKey]="'manage-suppliers'">
    <mat-form-field appearance="outline">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filter vendors" />
    </mat-form-field>

    <table mat-table appStickyTableHeader [maxHeight]="'calc(100vh - 200px)'" [dataSource]="dataSource" matSort (matSortChange)="sortData($any($event))" class="mat-elevation-z8">
      <ng-container matColumnDef="rowNumber">
        <th mat-header-cell *matHeaderCellDef style="width:48px">#</th>
        <td mat-cell *matCellDef="let vendor; let i = index" [attr.title]="vendor?.name">{{ i + 1 }}</td>
      </ng-container>

      <ng-container matColumnDef="vendorName">
        <th mat-header-cell *matHeaderCellDef
          appColumnFilter="name" [appColumnSort]="'vendorName'" [filterSort]="sort"
          [filterDataSource]="dataSource">Vendor Name</th>
        <td mat-cell *matCellDef="let vendor">{{ vendor.name }}</td>
      </ng-container>

      <ng-container matColumnDef="users">
        <th mat-header-cell *matHeaderCellDef>Users</th>
        <td mat-cell *matCellDef="let vendor">
          @if (vendor.users?.length) {
            <mat-chip-list aria-label="Assigned users">
              @for (user of vendor.users; track user) {
                <mat-chip [removable]="true" (removed)="removeUser(vendor, user)" class="custom-chip" [attr.title]="user.name">
                  {{ user.name }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              }
            </mat-chip-list>
          } @else {
            <span>-</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let vendor">
          <button
            type="button"
            class="aker-context-icon-button"
            mat-raised-button
            (click)="openAddUsersDialog(vendor)"
            aria-label="Add users"
          >
            <mat-icon aria-hidden="true">group_add</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let vendor; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
